import { msalInstance } from "../../index";
import { store } from "../../index";

export const clearSession = () => {

  const account = msalInstance.getActiveAccount();
  msalInstance.logoutRedirect({
    account,
    postLogoutRedirectUri: window.location.origin
  });

  sessionStorage.removeItem("token");
  sessionStorage.removeItem("auth-token");
  sessionStorage.removeItem("expiresOn");
  sessionStorage.removeItem("users");
  sessionStorage.removeItem("totalUser");
  sessionStorage.removeItem("storeLastUpdated");
}


export const getCredentialsIfValid = () => {
  let userDetailsState = store.getState().account.userAccountDetails;
  var currentEmail = null;
  let credentials = null;
  if(userDetailsState != null){
    currentEmail = userDetailsState.PetParentInfo.Email;
  }
  let params = new URL(document.location.toString()).searchParams;
  let userId = params.get("userId");
  var checkUsers = sessionStorage.getItem("users");
  if(checkUsers != null ){
    var users = JSON.parse(checkUsers);
    if(users.length > 1){
      
      users.map((item) =>{
        
        if(item.username == currentEmail || item.user == userId){
          let nowTimeStamp = new Date().getTime();
          if (parseInt(item.expiresOn) && nowTimeStamp <= item.expiresOn)
          {
            credentials =  item;
          }
        }}
      );
    }
    else{
      if(users.username == currentEmail || users.user == userId){
        let nowTimeStamp = new Date().getTime();
        if (parseInt(users.expiresOn) && nowTimeStamp <= users.expiresOn)
        { 
          credentials =  users;
        }
      }
    }
  }
  if(credentials == null){
  let expiryTimeStamp = sessionStorage.getItem("expiresOn");
  let nowTimeStamp = new Date().getTime();
  if (expiryTimeStamp && nowTimeStamp <= expiryTimeStamp) {
    let token = sessionStorage.getItem("token");
    if (token) {
      credentials = JSON.parse(token);
      
      return credentials;
    }
  }
  }
  return credentials;
  
};


export const getAuthToken = () => {
  let token = sessionStorage.getItem("auth-token");
  
  if (token) {
    return token;
  }
  return null;
}


export const saveCredentials = ({username, password, rememberMe}, authResponse) => {
  let expiryTimeStamp;
  let currentTimeStamp = new Date().getTime();

  if (authResponse.expires_in) {
    expiryTimeStamp = currentTimeStamp + authResponse.expires_in * 1000;
  } else if (authResponse.exp) {
    expiryTimeStamp = authResponse.exp * 1000;
  } else {
    expiryTimeStamp = currentTimeStamp + 3600 * 1000;
  }

  let accessToken = authResponse.access_token 
    || sessionStorage.getItem("auth-token") 
    || null;

 let checkUser = sessionStorage.getItem("users");  
 var data = new Array();
 if(checkUser == null){
   data = {
     user:"u1",
     username,
     expiresOn:expiryTimeStamp,
     token:accessToken
   }
   sessionStorage.setItem("totalUser",1);
   sessionStorage.setItem("users",JSON.stringify(data));
 }
 else{
   var userCount = parseInt(sessionStorage.getItem("totalUser")) + 1;
   let newUser = {
       user:"u"+userCount,
       username,
       expiresOn:expiryTimeStamp,
       token:accessToken
   };
   data.push(JSON.parse(checkUser));
   data.push(newUser);
   sessionStorage.setItem("totalUser",userCount);
   sessionStorage.setItem("users",JSON.stringify(data));
 }

 let credentials = {
   username
 }
 let cipherText = JSON.stringify(credentials);
 sessionStorage.setItem("token", cipherText);
 if (accessToken) {
   sessionStorage.setItem("auth-token", accessToken);
 }
 sessionStorage.setItem("expiresOn", expiryTimeStamp);
};


